export const DECREASE = "DECREASE"
export const INCREASE = "INCREASE"
export const RESET = "RESET"
export const CLEAR_CART = "CLEAR_CART"
export const REMOVE = "REMOVE"
export const GET_TOTAL = "GET_TOTAL"
export const TOGGLE_AMOUNT = "TOGGLE_AMOUNT"
